export default __webpack_public_path__ + "static/media/trash.6dba31e5.svg";